<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em> <span>/</span
            ><span @click.prevent="toProMain" class="pointer px-0" style="color: #1a73e8">參展產品</span><span>/</span
            ><span @click.prevent="toHistoryExhibitors" class="pointer px-0" style="color: #1a73e8">歷屆參展列表</span
            ><span>/</span>選擇產品
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox" v-if="submitStatus == 1">
          <div class="text-center">
            <div>
              <img src="@/assets/images/Spinner3.gif" alt="" />
            </div>
            <div class="mt-4 font-weight-bold" style="font-size: 18px">產品複製中...</div>
            <div class="mt-3" style="font-size: 18px">請勿關閉視窗，以避免複製失敗！</div>
          </div>
        </div>

        <div class="contentBox" v-if="submitStatus == 3">
          <div class="text-center">
            <div>
              <img src="@/assets/images/tick.png" width="100px" alt="" />
            </div>
            <div class="mt-4 font-weight-bold" style="font-size: 18px">產品複製成功，請自行手動調整產品分類</div>
            <div class="btn btn-primary mt-5 px-3 py-2" style="font-size: 18px" @click="toProMain">返回參展產品頁</div>
          </div>
        </div>

        <div class="contentBox" v-if="submitStatus == 2">
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>
          <h1>選擇產品</h1>

          <p class="my-3">&nbsp;</p>
          <p class="alert">
            您已經建立 <span class="red" name="existProd">{{ totalNo }}</span> 個產品，還可以複製
            <span class="red" name="leftAmount">{{ ProductAmount - totalNo }}</span> 個產品。
          </p>

          <div class="mb-3 mt-4">
            <h3>請勾選欲複製的產品</h3>
          </div>

          <div class="row justify-content-between align-items-center my-4 mx-1">
            <div class="d-flex align-items-center">
              <div>
                <img
                  :src="`//www.ccie.com.tw/exhibition/images/exlogo/${SelectedExh.ExhLogo}`"
                  class="img-fluid imgSize"
                  width="50px"
                />
              </div>
              <div class="ml-2">
                <h4>{{ SelectedExh.Exhibition }}</h4>
              </div>
            </div>

            <div class="PcDevice">
              <div v-if="SelectAllStatus" class="btn btn-primary btn-lg" @click.prevent="AreaSettingAll">全選</div>
              <div v-else class="btn btn-primary btn-lg" @click.prevent="ClearSettingAll">清除全部</div>
            </div>

            <div class="MbDevice">
              <div v-if="SelectAllStatus" class="btn btn-primary mt-1" @click.prevent="AreaSettingAll">全選</div>
              <div v-else class="btn btn-primary mt-1" @click.prevent="ClearSettingAll">清除全部</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4" v-for="(item, index) in ProductList" :key="index">
              <label :for="item.No" class="pointer" style="display: block">
                <div class="d-flex align-items-center border p-2 mb-3">
                  <div class="d-flex align-items-center">
                    <div class="mr-sm-3 mr-2 ml-sm-1 ml-0 mt-1">
                      <input
                        type="checkbox"
                        :id="item.No"
                        :value="item.ProNo"
                        v-model="optionPro"
                        class="pointer"
                        style="width: 20px; height: 19px"
                      />
                    </div>
                  </div>
                  <div class="mr-4">
                    <label :for="item.No" class="pointer">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                        class="mt-2"
                        width="130px"
                      />
                    </label>
                  </div>

                  <div class="d-flex" style="font-size: 18px">
                    <label :for="item.No" class="pointer">
                      <div class="ListContent">
                        <h5 class="mb-2 font-weight-bold ellipsis3">
                          {{ item.ProName }}
                        </h5>

                        <p class="ellipsis2">分類名稱：{{ item.CatName }}　</p>
                      </div>
                    </label>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div class="PcDevice">
            <div class="d-flex justify-content-center mt-4">
              <div class="btn btn-lg btn-primary mx-3 text-nowrap" @click.prevent="AddPreviousPro">確認複製</div>

              <div class="btn btn-lg btn-secondary mx-3 text-nowrap ml-3" @click.prevent="toHistoryExhibitors">
                回前頁
              </div>
            </div>
          </div>
          <div class="MbDevice">
            <div class="d-flex justify-content-center my-4">
              <div class="btn btn-primary mx-3 text-nowrap" @click.prevent="AddPreviousPro">確認複製</div>

              <div class="btn btn-secondary mx-3 text-nowrap ml-3" @click.prevent="toHistoryExhibitors">回前頁</div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '選擇產品 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        ProductAmount: '',
        ProductData: {},
        companyName: '',
        ecompanyName: '',
        SelectCat: '',
        ProductCategory: [],
        BoothNo: '',

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        ProductList: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        lang: 'tw',
        logoImg: '',

        //判斷各頁狀態儀表版值
        OnlineExpolayoutStatus: '',
        PressReleaseStatus: '',
        VideoStatus: '',
        ProductStatus: '',
        BasicinformationStatus: '',

        //判斷儀表板是否有線上展
        HasOnlineExpo: '',
        openOnlineExpo: '',
        showOnlineStatus: false,
        eventId: '',
        hasHistoryPro: false,
        ProRegNo: '',

        optionPro: [], //給進階搜尋的Area欄位
        s_optionPro: '',
        SelectedExh: {},

        categoryAll: [],
        SelectAllStatus: true,

        submitStatus: 2,

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      AreaSettingAll() {
        const vm = this
        vm.optionPro = vm.categoryAll
        vm.SelectAllStatus = false
      },

      ClearSettingAll() {
        const vm = this
        vm.optionPro = []
        vm.SelectAllStatus = true
      },

      toProMain() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
        }
      },

      toHistoryExhibitors() {
        const vm = this

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productHistoryExh?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/productHistoryExh?no=${vm.RegNo}`
        }
      },

      AddPreviousPro() {
        const vm = this

        const url = `/apiExhibitors/Product/CopyProduct/${vm.RegNo}`

        const info = {
          ProNoArray: vm.s_optionPro,
          CSRF: vm.CSRF_Token,
        }

        // console.log(info)

        if (!vm.s_optionPro) {
          if (vm.lang == 'tw') {
            alert('請先選取欲複製之產品')
          } else {
            alert('Please select the products you want to copy.')
          }
        } else {
          vm.submitStatus = 1

          axios.post(url, info).then(function (response) {
            // console.log(response.data)
            if (response.data.Code == 200) {
              vm.submitStatus = 3
            } else if (response.data.Code == 500) {
              if (vm.lang == 'tw') {
                alert('系統忙線中，請稍後再試')
                vm.submitStatus = 2
              } else {
                alert('System is busy, please try again later.')
                vm.submitStatus = 2
              }
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              if (vm.lang == 'tw') {
                alert('複製失敗！原因: 產品數量超過上限，請確認您還可以複製的產品數量')
                vm.submitStatus = 2
              } else {
                alert(
                  'Copy failed. Reason: Number of products exceeds the limit. Please confirm the number of products allowed to be copied.'
                )
                vm.submitStatus = 2
              }
            } else if (response.data.Code == 254) {
              if (vm.lang == 'tw') {
                alert('產品序號錯誤')
                vm.submitStatus = 2
              } else {
                alert('ProductNo Error！')
                vm.submitStatus = 2
              }
            }
          })
        }
      },
    },

    watch: {
      optionPro: function (newValue) {
        this.s_optionPro = newValue.toString()
      },
    },

    created() {
      const vm = this

      //取得語系

      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function () {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop').stop().fadeOut(222)
            }
          })
          .scroll()
      })

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href

      //取得本次報名表RegNo
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]

      //取得欲複製的報名表ProRegNo

      if (currentUrl.split('ProRegNo=')[1]) {
        vm.ProRegNo = currentUrl.split('ProRegNo=')[1]
      }

      //取得當前展覽
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.ProRegNo}?lang=${vm.lang}`)
        .then((response) => {
          vm.SelectedExh = response.data.Data
        })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      // 取得產品額度
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response.data.Data)

        vm.ProductAmount = response.data.Data.ProductAmount
        vm.companyName = response.data.Data.Company
        vm.ecompanyName = response.data.Data.eCompany
      })

      //取得此欲複製的展的產品列表
      let url = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.ProRegNo}?mode=more&Page=`

      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductList = response.data.Data

        vm.ProductList.forEach((item) => {
          vm.categoryAll.push(item.ProNo)
        })
      })

      //取得此展已報名的產品數量
      let url3 = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=more&Page=`

      axios.get(url3).then(function (response) {
        // console.log(response)

        if (response.data.Code == 404) {
          vm.totalNo = 0
        } else {
          vm.totalNo = response.data.datatotal
        }
      })

      //是否有歷年產品紀錄

      let url2 = `https://www.chanchao.com.tw/apiExhibitors/Product/PreviousRegister?RegNo=${vm.RegNo}&lang=${vm.lang}`

      axios.get(url2).then(function (response) {
        if (response.data.datatotal) {
          vm.hasHistoryPro = true
        } else {
          vm.hasHistoryPro = false
        }
      })
    },
  }
</script>

<style lang="scss">
  .card-footer {
    padding: 0.5rem 0.2rem;
    background-color: rgb(255 255 255 / 3%);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .uncomplete {
    background-image: url('../../../assets/images/tickGray.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  .complete {
    background-image: url('../../../assets/images/tick.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }
</style>
